// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "LeftNav-module--cds--assistive-text--a81ac";
export var cdsVisuallyHidden = "LeftNav-module--cds--visually-hidden--c9557";
export var currentItem = "LeftNav-module--current-item--89e8b";
export var divider = "LeftNav-module--divider--c2516";
export var dividerSpace = "LeftNav-module--divider-space--9390f";
export var hideFeedback = "LeftNav-module--hide-feedback--06122";
export var outboundLink = "LeftNav-module--outboundLink--8ff74";
export var showFeedback = "LeftNav-module--show-feedback--84ad4";
export var sideNavDark = "LeftNav-module--side-nav--dark--b75b3";
export var sideNavWhite = "LeftNav-module--side-nav--white--647c8";
export var skeleton = "LeftNav-module--skeleton--8fc37";